import { em } from 'polished'
import styled from 'styled-components'

import SectionWrapper from 'components/SectionWrapper'

export const SectionsWrapperStyled = styled(SectionWrapper)`
  background-color: ${p => p.theme.colors.purpleHeart};
`
export const FaqBlockWrapper = styled.div`
  padding-top: ${em(20)};

  ${p => p.theme.mq.upMd} {
    padding-top: ${em(40)};
  }

  ${p => p.theme.mq.upLg} {
    padding-top: ${em(160)};
  }
`
